import React, { useEffect, useRef } from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './Hero.scss';
import WalletIcon from '../UI/SVG/WalletIcon';
import MoneyIcon from '../UI/SVG/MoneyIcon';
import CartICon from '../UI/SVG/CartIcon';
import animateHero from './heroAnimations';
import UbisoftLogoGradient from '../UI/SVG/UbisoftLogoGradient';
import ArrowIcon from '../UI/SVG/ArrowIconProps.';
import { sendEvent } from '../../utils';

interface IHeroProps {
  context?: IContent;
}

const getDescriptionIcon = (value: string) => {
  switch (value) {
    case 'money':
      return <MoneyIcon fill='#35c1cf' />;

    case 'cart':
      return <CartICon fill='#35c1cf' />;

    default:
      return null;
  }
};

const Hero = ({ context }: IHeroProps) => {
  const walletIcon = useRef<HTMLDivElement>();
  const heroTopTitle = useRef<HTMLDivElement>();
  const heroDescriptionRef = useRef<HTMLDivElement>();
  const backgroundRef = useRef<HTMLDivElement>();
  const heroBottomRef = useRef<HTMLDivElement>();

  useEffect(() => {
    animateHero({
      walletIcon,
      heroTopTitle,
      heroDescriptionRef,
      backgroundRef,
      heroBottomRef
    });
  }, []);

  return (
    <section className='wallet-hero'>
      <div className='hero-background'>
        <div className='hero-background__inner' ref={backgroundRef}>
          <UbisoftLogoGradient />
        </div>
      </div>
      <div className='wallet-container wallet-hero__inner'>
        <div className='hero-top'>
          <div className='hero-top__icon' ref={walletIcon}>
            <WalletIcon fill='#35c1cf' />
          </div>
          <div className='hero-top__title'>
            <h1 ref={heroTopTitle}>
              {context.hero.title}
              <div className='right'>
                <span className='icon'>
                  <WalletIcon fill='#35c1cf' />
                </span>
                <span className='content'>{context.hero.title_wallet}</span>
              </div>
            </h1>
          </div>
        </div>
        <div className='hero-description' ref={heroDescriptionRef}>
          {context.hero.wallet_description.map((item, index) => (
            <div className='hero-description__inner' key={`hero_desc_${index}`}>
              <div className='icon'>{getDescriptionIcon(item.icon)}</div>
              <div className='title'>{item.title}</div>
            </div>
          ))}
        </div>
        <div className='hero-bottom' ref={heroBottomRef}>
          <div className='hero-subdescription'>
            <p>{context.hero.wallet_subdescription}</p>
          </div>
          <div className='hero-cta-wrapper'>
            <a
              href={context.hero.cta.link}
              onClick={() => sendEvent(context.hero.cta.tracking)}
              className={`btn btn__${context.hero.cta.type}`}
              data-alt-text={context.hero.cta.content}
            >
              <span>{context.hero.cta.content}</span>
            </a>
          </div>
        </div>
        <div className='hero-scroll-arrow'>
          <ArrowIcon fill='#35c1cf' direction='bottom' width={40} />
        </div>
      </div>
    </section>
  );
};

export default withContent(Hero);
